export const merchantOperatingHoursCardClass =
  'rounded-merchant-stat bg-merchant-surface p-5 shadow-merchant-stat lg:p-6'

export const merchantOperatingHoursTimeInputClass =
  'w-[6.75rem] rounded-lg border border-merchant-divider bg-merchant-surface px-2.5 py-2 text-center text-sm font-medium text-merchant-ink outline-none focus:border-merchant-primary focus:ring-2 focus:ring-merchant-primary/10'

/** Mobile onboarding hours (Figma 715:756): filled chips, no hairline border */
export const merchantOperatingHoursTimeInputOnboardingMobileClass =
  'w-[6.75rem] rounded-lg border border-transparent bg-merchant-input px-2.5 py-2 text-center text-sm font-medium text-merchant-ink outline-none focus:border-merchant-primary/30 focus:ring-2 focus:ring-merchant-primary/10'
